import { bpmsResourcesManagerApi } from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class SettingsInterestRateStoreClass extends BasicStore<any> {
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-56-interest-rate-settings.json';

    itemEditFormKey = '';

    api: BasicStoreApi<any> = {
        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm({ formKey }, options),
            );
        },
    };
}

export const SettingsInterestRateStore = new SettingsInterestRateStoreClass();
